export default "assets/images/line-hero-99f92595.svg";